import { apiGet, apiPost } from './utils';

export interface IncomingPhoneNumber {
  key: string;
  uuid: string;
  identity: string;
  associated_type: string;
  associated_uuid: string;
  phone_number: string;
  extension: string;
  formatted_phone_number: string;
}

export const incomingPhoneNumberApi = {
  async get(
    associatedType: string,
    associatedUuid: string
  ): Promise<IncomingPhoneNumber> {
    return apiGet<IncomingPhoneNumber>(
      '/incoming-phone-number/get-for-user',
      {
        associated_type: associatedType,
        associated_uuid: associatedUuid,
      }
    );
  },

  async getOrCreate(
    associatedType: string,
    associatedUuid: string
  ): Promise<IncomingPhoneNumber> {
    return apiPost<IncomingPhoneNumber>(
      '/incoming-phone-number/get-or-create-for-user',
      {
        associated_type: associatedType,
        associated_uuid: associatedUuid,
      }
    );
  },
};
